import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { IncidentInvestigationDashboardComponent } from './incident-investigation-dashboard.component'
import { IncidentInvestigationListComponent } from './incident-investigation-list.component'

@Component({
    selector: 'app-incident-investigation',
    templateUrl: './incident-investigation.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        IncidentInvestigationDashboardComponent,
        IncidentInvestigationListComponent,
    ],
})
export class IncidentInvestigationComponent extends BaseComponent {
    @ViewChild(IncidentInvestigationDashboardComponent)
    dashboard?: IncidentInvestigationDashboardComponent

    activeTab = 0

    constructor() {
        super()
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.SafetyIncidentInvestigationDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
